import type { CSSProperties, ElementType, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Stack.module.css';

export type StackGap = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'fluid';
export type StackAlign = 'start' | 'center' | 'end' | 'stretch';

export interface StackProps {
  children: ReactNode;
  /** `column` (por defecto) o `row`. En `row` los hijos envuelven solos. */
  direction?: 'column' | 'row';
  gap?: StackGap;
  align?: StackAlign;
  justify?: 'start' | 'center' | 'end' | 'between';
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
}

/** Apilado vertical/horizontal con el ritmo del sistema. Nada de margins sueltos. */
export function Stack({
  children,
  direction = 'column',
  gap = 'md',
  align = 'stretch',
  justify = 'start',
  as: Tag = 'div',
  className,
  style,
}: StackProps) {
  return (
    <Tag
      className={cx(
        styles.stack,
        styles[direction],
        styles[`gap-${gap}`],
        styles[`align-${align}`],
        styles[`justify-${justify}`],
        className,
      )}
      style={style}
    >
      {children}
    </Tag>
  );
}
